import gql from "graphql-tag";

export const newCountryFragment = gql`
  fragment NewCountryFragment on Country {
    id
    isoTwoCode
    isoThreeCode
    isoNumberCode
    name
    displayOrder
    regionsCount
    defaultCurrency {
      id
      code
      name
    }
    defaultLanguage {
      id
      language
      languageCode
    }
    enable
  }
`;

export const countryDetailsFragment = gql`
  ${newCountryFragment}
  fragment CountryDetailsFragment on Country {
    ...NewCountryFragment
    regions {
      id
      name
      code
      enable
      displayOrder
    }
  }
`;
